import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { MdDelete, MdUpload } from "react-icons/md";
import { toast } from "react-toastify";
import { addSuspectService } from "../../../services/api-service"; 
// OR simply: import { addSuspectService } from "services/api-service";
import AutoFaceIdCamera from "components/add-student-details/AutoFaceIdCamera";
import "components/add-student-details/AddStudents.css";
const AddSuspect = () => {
  const [full_name, setFullName] = useState("");
  const [email, setEmailId] = useState("");
  const [mobile_no, setMobileNumber] = useState("");
  
  const [allImages, setAllImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleMultipleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setAllImages((prev) => [...prev, ...files]);
  };

  const handleImageCapture = (files) => {
    setAllImages((prev) => [...prev, files]);
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (indexToRemove) => {
    setAllImages((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const handleSubmit = () => {
    if (allImages.length === 0) {
      toast.warn("Please upload or capture at least one image of the suspect.");
      return;
    }

    setLoading(true);

    Promise.all(
      allImages.map((img) => {
        if (img instanceof File) {
          return readFileAsBase64(img);
        }
        return img;
      })
    )
      .then((base64Images) => {
        // Strip the Data URL prefix if present
        const processedImages = base64Images.map((img) => 
          img.includes(",") ? img.split(",")[1] : img
        );

        const payload = {
          full_name,
          email,
          mobile_no,
          images: processedImages,
        };

        return addSuspectService(payload);
      })
      .then((res) => {
        if (res.data?.status === "success" || res.status === 201) {
          toast.success(`Suspect Added! ID: ${res.data.suspect_id}`);
          setFullName("");
          setEmailId("");
          setMobileNumber("");
          setAllImages([]);
          history.push("/admin/FaceDetails"); // Redirect back to details page
        } else {
          toast.error("Failed to add suspect.");
        }
      })
      .catch((error) => {
        console.error("Error adding suspect:", error);
        toast.error(error.response?.data?.detail || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="container mt-4">
        <div className="form-section">
          <h2>Register Suspect</h2>
          <p className="text-muted mb-4">
            Text fields are optional. Add any known details or leave them blank.
          </p>

          <div className="form-row">
            <div className="form-group w-100">
              <label className="lebcs">Full Name </label>
              <input
                className="Asss"
                type="text"
                placeholder="Unknown"
                value={full_name}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="lebcs">Email (Optional)</label>
              <input
                className="Asss"
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmailId(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label className="lebcs">Mobile (Optional)</label>
              <input
                className="Asss"
                type="tel"
                placeholder="Contact Number"
                value={mobile_no}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* --- CAMERA AND GALLERY SECTION --- */}
        <div className="camera-section">
          <h2>Live Camera</h2>
          <AutoFaceIdCamera onImageCapture={handleImageCapture} />
          
          <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15px" }}>
            
            <label style={{ 
                color: '#fff', backgroundColor: '#dc3545', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold', boxShadow: '0 4px 10px rgba(220, 53, 69, 0.3)', marginBottom: '15px'
              }} 
              htmlFor="suspect_images"
            >
              Upload Image(s)
              <MdUpload size={20} />
              <input
                id="suspect_images"
                accept=".png, .jpeg, .jpg"
                style={{ display: "none" }}
                type="file"
                multiple
                onChange={handleMultipleImageChange}
              />
            </label>

            {allImages.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "center", width: "100%" }}>
                {allImages.map((img, index) => {
                  const isFile = img instanceof File || img instanceof Blob;
                  const imgSrc = isFile ? URL.createObjectURL(img) : img;

                  return (
                    <div key={index} style={{ position: "relative", width: "70px", height: "70px" }}>
                      <img 
                        src={imgSrc} 
                        alt={`captured-face-${index}`} 
                        style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px", border: "2px solid #dc3545" }} 
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        style={{
                          position: "absolute", top: "-6px", right: "-6px", background: "#ff4444", color: "white", border: "none", borderRadius: "50%", width: "22px", height: "22px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", boxShadow: "0 2px 5px rgba(0,0,0,0.4)"
                        }}
                      >
                        <MdDelete size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ width: '100%', paddingLeft: '172px', paddingRight: '172px', marginTop: '20px', marginBottom: '40px' }}>
        <button 
          className="upload-btn" 
          onClick={handleSubmit} 
          style={{ width: '100%', backgroundColor: '#dc3545' }}
        >
          Add Suspect Record
        </button>
      </div>
    </>
  );
};

export default AddSuspect;
